import * as z from 'zod';
import { i18n } from '@lingui/core';
import { errorMessages } from './portal-messages';

export const detailsSchema = (portalId: string) =>
	z
		.object({
			firstname: z.string().min(1),
			lastname: z.string().min(1),
			email: z.email(),
			repeatEmail: z.email(),
			certificate: z.boolean(),
			documentType: z.enum(['id', 'passport', 'taxId', 'nie', 'others']),
			documentNumber: z.string(),
			streetName: z.string(),
			streetNumber: z.string(),
			additionalInfo: z.string().or(z.undefined()),
			city: z.string(),
			cp: z.string(),
			country: z.string(),
			region: z.string(),
			province: z.string(),
			termsAndConditions: z.boolean().refine((val) => val, { message: i18n._(errorMessages.termsAndConditions) }),
			ngosTermsAndConditions: z.boolean(),
			telefonicaTermsAndConditions: z.boolean(),
			newsletter: z.boolean(),
		})
		.check((ctx) => {
			if (ctx.value.repeatEmail !== ctx.value.email) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.emailsDoNotMatch),
					path: ['repeatEmail'],
					input: ctx.value,
				});
			}

			if (!ctx.value.documentNumber && (ctx.value.certificate || portalId === 'telefonica')) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.required),
					path: ['documentNumber'],
					input: ctx.value,
				});
			}

			if (!ctx.value.streetName && (ctx.value.certificate || portalId === 'telefonica')) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.required),
					path: ['streetName'],
					input: ctx.value,
				});
			}

			if (!ctx.value.streetNumber && (ctx.value.certificate || portalId === 'telefonica')) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.required),
					path: ['streetNumber'],
					input: ctx.value,
				});
			}

			if (!ctx.value.city && (ctx.value.certificate || portalId === 'telefonica')) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.required),
					path: ['city'],
					input: ctx.value,
				});
			}

			if (!ctx.value.cp && (ctx.value.certificate || portalId === 'telefonica')) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.required),
					path: ['cp'],
					input: ctx.value,
				});
			}

			if (!ctx.value.country && (ctx.value.certificate || portalId === 'telefonica')) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.required),
					path: ['country'],
					input: ctx.value,
				});
			}

			if (!ctx.value.region && (ctx.value.certificate || portalId === 'telefonica')) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.required),
					path: ['region'],
					input: ctx.value,
				});
			}

			if (!ctx.value.province && (ctx.value.certificate || portalId === 'telefonica')) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.required),
					path: ['province'],
					input: ctx.value,
				});
			}

			if (
				ctx.value.country !== 'AD' &&
				ctx.value.region === '' &&
				(ctx.value.certificate || portalId === 'telefonica')
			) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.required),
					path: ['region'],
					input: ctx.value,
				});
			}

			if (
				ctx.value.country !== 'AD' &&
				ctx.value.province === '' &&
				(ctx.value.certificate || portalId === 'telefonica')
			) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.required),
					path: ['province'],
					input: ctx.value,
				});
			}

			if (!ctx.value.telefonicaTermsAndConditions && portalId === 'telefonica') {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.termsAndConditions),
					path: ['telefonicaTermsAndConditions'],
					input: ctx.value,
				});
			}

			if (!ctx.value.ngosTermsAndConditions && ctx.value.certificate) {
				ctx.issues.push({
					code: 'custom',
					message: i18n._(errorMessages.termsAndConditions),
					path: ['ngosTermsAndConditions'],
					input: ctx.value,
				});
			}
		});

export type DetailsSchema = ReturnType<typeof detailsSchema>;
export type Details = z.infer<DetailsSchema>;
